// extracted by mini-css-extract-plugin
module.exports = {"page":"KV-z","cartModal":"LV-z","checkout":"MV-z","placeholder":"NV-z","account":"OV-z"};